// extracted by mini-css-extract-plugin
export var fadeIn = "_hg-1";
export var modalContent = "_hg-3";
export var overlay = "_hg-0";
export var popoverContent = "_hg-2";
export var results = "_hg-5";
export var searchInputWrapper = "_hg-4";